module.exports = __webpack_public_path__ + "img/mont-blanc-treks.3e6965bb.png";